import React, { lazy } from "react";

const TopShopModal = lazy(() =>
  import("./TopShopModal").then((module) => ({ default: module.TopShopModal }))
);

interface LazyTopShopModalProps {
  onClose: () => void;
}

export const LazyTopShopModal: React.FC<LazyTopShopModalProps> = ({
  onClose,
}) => {
  return <TopShopModal isOpen={true} onClose={onClose} />;
};
